var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "div",
        { staticClass: "subTitle" },
        [
          _c(
            "el-link",
            {
              attrs: {
                icon: "el-icon-arrow-left",
                underline: false,
                href: "#/clientManagement"
              }
            },
            [_vm._v("Client Management")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "h3",
        {
          staticClass: "title",
          attrs: { content: "edit", placement: "bottom" }
        },
        [_vm._v("Edit Account")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "detailContent" },
        [
          _c("div", { staticClass: "requireRmarks" }, [
            _vm._v("*Required Fields")
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "formAccount",
              attrs: {
                "label-width": "50%",
                "label-position": "left",
                model: _vm.formAccount,
                rules: _vm.formAccountRules
              }
            },
            [
              _c("el-row", [_c("h4", [_vm._v("Profile")])]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Client ID", prop: "clientID" } },
                        [_c("p", [_vm._v(_vm._s(_vm.formAccount.clientID))])]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.formAccount.userStatus != "OPENED"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Username", prop: "UserName" } },
                            [
                              _c("p", [
                                _vm._v(_vm._s(_vm.formAccount.userName))
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.formAccount.isDummyUser
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Last Name",
                                prop: "lastName",
                                error: _vm.formAccount.lastName
                                  ? ""
                                  : "Last Name cannot be empty"
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { maxlength: "50" },
                                model: {
                                  value: _vm.formAccount.lastName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formAccount, "lastName", $$v)
                                  },
                                  expression: "formAccount.lastName"
                                }
                              })
                            ],
                            1
                          )
                        : _c(
                            "el-form-item",
                            { attrs: { label: "Last Name" } },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formAccount.lastName
                                      ? _vm.formAccount.lastName
                                      : "-"
                                  )
                                )
                              ])
                            ]
                          )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "First Name", prop: "firstName" } },
                        [
                          _vm.formAccount.isDummyUser
                            ? _c("el-input", {
                                attrs: { maxlength: "50" },
                                model: {
                                  value: _vm.formAccount.firstName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formAccount, "firstName", $$v)
                                  },
                                  expression: "formAccount.firstName"
                                }
                              })
                            : _c("p", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.formAccount.firstName
                                        ? _vm.formAccount.firstName
                                        : "-"
                                    ) +
                                    "\n            "
                                )
                              ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.formAccount.isDummyUser
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "Date Of Birth", prop: "dob" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  format: "yyyy/MM/dd",
                                  placeholder: "Date of Birth"
                                },
                                model: {
                                  value: _vm.formAccount.dob,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formAccount, "dob", $$v)
                                  },
                                  expression: "formAccount.dob"
                                }
                              })
                            ],
                            1
                          )
                        : _c(
                            "el-form-item",
                            { attrs: { label: "Date Of Birth" } },
                            [
                              _c("p", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.formAccount.dob
                                        ? _vm.$commonjs.paramFormatDate(
                                            _vm.formAccount.dob,
                                            true
                                          )
                                        : "-"
                                    ) +
                                    "\n            "
                                )
                              ])
                            ]
                          )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "ITIN", prop: "ITIN" } },
                        [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.formAccount.itin
                                  ? _vm.formAccount.itin
                                  : "-"
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "ITN", prop: "ITN" } },
                        [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.formAccount.itn ? _vm.formAccount.itn : "-"
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("General information")])]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "border-box" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      !_vm.formAccount.isDummyUser
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Salesforce Email address",
                                    prop: "salesforceEmail"
                                  }
                                },
                                [
                                  _c("p", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.formAccount.salesforceEmail
                                            ? _vm.formAccount.salesforceEmail
                                            : "-"
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Mobile Phone", prop: "phone" } },
                            [
                              _c("p", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.formAccount.cellularphone
                                        ? _vm.formAccount.cellularphone
                                        : "-"
                                    ) +
                                    "\n              "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Residency" } },
                            [
                              _c("p", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.formAccount.residencyID
                                        ? _vm.formAccount.residencyID
                                        : "-"
                                    ) +
                                    "\n              "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Preferred Language",
                                prop: "salesforceLanguage"
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.formAccount.salesforceLanguage
                                        ? _vm.formAccount.salesforceLanguage
                                        : "-"
                                    ) +
                                    "\n              "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Citizenship",
                                prop: "Citizenship"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.formAccount.citizenship
                                      ? _vm.formAccount.citizenship
                                      : "-"
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("Correspondence Address")])]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "border-boxshadow" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Correspondence Address",
                                prop: "Correspondence Address"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.formAccount.addressLine1
                                      ? _vm.formAccount.addressLine1
                                      : "-"
                                  ) +
                                  "\n              "
                              ),
                              _c("br"),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.formAccount.addressLine2
                                      ? _vm.formAccount.addressLine2
                                      : " "
                                  ) +
                                  "\n              "
                              ),
                              _c("br"),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.formAccount.addressLine3
                                      ? _vm.formAccount.addressLine3
                                      : " "
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "City", prop: "City" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.formAccount.city
                                      ? _vm.formAccount.city
                                      : "-"
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Country ", prop: "Country " } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.formAccount.countryDesc
                                      ? _vm.formAccount.countryDesc
                                      : "-"
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "Province ", prop: "Province " }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.formAccount.province
                                      ? _vm.formAccount.province
                                      : "-"
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Postal Code",
                                prop: "Postal Code"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.formAccount.postalCode
                                      ? _vm.formAccount.postalCode
                                      : "-"
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "border-boxshadow" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "National ID",
                                prop: "National ID"
                              }
                            },
                            [
                              _vm.formAccount.nationalId
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { width: "100%" },
                                          on: {
                                            click: function($event) {
                                              return _vm.getPassportlink(
                                                _vm.formAccount.nationalId
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("View")]
                                      )
                                    ],
                                    1
                                  )
                                : _c("div", [_vm._v("-")])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Passport", prop: "Passport" } },
                            [
                              _vm.formAccount.passport
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { width: "100%" },
                                          on: {
                                            click: function($event) {
                                              return _vm.getPassportlink(
                                                _vm.formAccount.passport
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("View")]
                                      )
                                    ],
                                    1
                                  )
                                : _c("div", [_vm._v("-")])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "UpdateProfileLatestStatus  ",
                                prop: ""
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.formAccount
                                        .userUpdateProfileLatestStatus === -1
                                        ? "REJECT"
                                        : _vm.formAccount
                                            .userUpdateProfileLatestStatus === 0
                                        ? "PENDING"
                                        : _vm.formAccount
                                            .userUpdateProfileLatestStatus === 1
                                        ? "APPROVED"
                                        : _vm.formAccount
                                            .userUpdateProfileLatestStatus === 9
                                        ? "INVALID"
                                        : "-"
                                    ) +
                                    "\n              "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("Setting")])]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "border-boxshadow" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Market Updates",
                                prop: "Market updates"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.formAccount.marketUpdates
                                      ? _vm.formAccount.marketUpdates
                                      : "-"
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "Corporate", prop: "Corporate" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.formAccount.corporate
                                      ? _vm.formAccount.corporate
                                      : "-"
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("Sales Information")])]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "border-boxshadow" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Sales Office",
                                prop: "Sales Office"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.formAccount.salesOffice
                                      ? _vm.formAccount.salesOffice
                                      : "-"
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("el-form-item", { attrs: { label: "Region" } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.formAccount.salesforceRegion
                                    ? _vm.formAccount.salesforceRegion
                                    : "-"
                                ) +
                                "\n            "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Sales Representative Name",
                                prop: "Sales Representative name"
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.formAccount.representativeName)
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Servicing Channel Type",
                                prop: "salseforceServicingChannelType"
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formAccount
                                      .salseforceServicingChannelType
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Referral Company / Individual Planner",
                                prop: "salseforceServicingChannelName"
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formAccount
                                      .salseforceServicingChannelName
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Referral Planner / Broker",
                                prop: "salseforceServicingFinancialPlanner"
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formAccount
                                      .salseforceServicingFinancialPlanner
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Sub-Referral Company",
                                prop: "salseforceReferredByIfa"
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formAccount.salseforceReferredByIfa
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Sub-Referral Planner",
                                prop: "salseforceReferredByPlanner"
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formAccount.salseforceReferredByPlanner
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Referred by (Client Lv)",
                                prop: "salseforceReferredByClientLv"
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formAccount.salseforceReferredByClientLv
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("Documents")])]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "border-boxshadow" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Investment Summary",
                                prop: "Investment Summary"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { width: "100%" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleInvestment(
                                        "pdl_activeProjects",
                                        false
                                      )
                                    }
                                  }
                                },
                                [_vm._v("View")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "My Documents",
                                prop: "My Documents"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { width: "100%" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleDocuments()
                                    }
                                  }
                                },
                                [_vm._v("View")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  this.formAccount.statement
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 50 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Investor Statement",
                                    prop: "Investor Statement"
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { width: "100%" },
                                      on: {
                                        click: function($event) {
                                          return _vm.download()
                                        }
                                      }
                                    },
                                    [_vm._v("Download")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("Booklet")])]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "border-boxshadow" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "English", prop: "English" } },
                            [
                              _c(
                                "p",
                                { staticStyle: { "word-break": "break-all" } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.formAccount.booklets.EN
                                          ? _vm.formAccount.booklets.EN
                                          : "-"
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Traditional Chinese",
                                prop: "Traditional Chinese"
                              }
                            },
                            [
                              _c(
                                "p",
                                { staticStyle: { "word-break": "break-all" } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.formAccount.booklets.ZH_HK
                                          ? _vm.formAccount.booklets.ZH_HK
                                          : "-"
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Japanese", prop: "Japanese" } },
                            [
                              _c(
                                "p",
                                { staticStyle: { "word-break": "break-all" } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.formAccount.booklets.JA
                                          ? _vm.formAccount.booklets.JA
                                          : "-"
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Simplified Chinese",
                                prop: "Simplified Chinese"
                              }
                            },
                            [
                              _c(
                                "p",
                                { staticStyle: { "word-break": "break-all" } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.formAccount.booklets.ZH_CN
                                          ? _vm.formAccount.booklets.ZH_CN
                                          : "-"
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row", [_c("h4", [_vm._v("Status")])]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "border-boxshadow" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 50 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Last success login date & time",
                                prop: "lastLogin"
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.formAccount.lastLogin
                                        ? _vm.$commonjs.paramFormatDate(
                                            _vm.formAccount.lastLogin
                                          )
                                        : "-"
                                    ) +
                                    "\n              "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Last password update date & time",
                                prop: "lastPwd"
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.formAccount.lastPwd
                                        ? _vm.$commonjs.paramFormatDate(
                                            _vm.formAccount.lastPwd
                                          )
                                        : "-"
                                    ) +
                                    "\n              "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Account Status",
                                prop: "userStatus"
                              }
                            },
                            [
                              _c(
                                "p",
                                {
                                  style:
                                    _vm.formAccount.userStatus == "ACTIVATED"
                                      ? "color:rgb(0,127,80)"
                                      : _vm.formAccount.userStatus == "OPENED"
                                      ? "color:rgb(85,130,160)"
                                      : "color:rgb(255,0,0)"
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$commonjs.userStatusMap(
                                          _vm.formAccount.userStatus
                                        )
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Activation Date & Time",
                                prop: "activationAt"
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.formAccount.activationAt
                                        ? _vm.$commonjs.paramFormatDate(
                                            _vm.formAccount.activationAt
                                          )
                                        : "-"
                                    ) +
                                    "\n              "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _vm.formAccount.userStatus != "OPENED"
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: { label: "Remarks", prop: "remarks" }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { maxlength: "100" },
                                    model: {
                                      value: _vm.formAccount.remarks,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formAccount,
                                          "remarks",
                                          $$v
                                        )
                                      },
                                      expression: "formAccount.remarks"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Profile Status" } },
                            [
                              _c("p", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.formAccount
                                        .userUpdateProfileLatestStatus === -1
                                        ? "REJECT"
                                        : _vm.formAccount
                                            .userUpdateProfileLatestStatus === 0
                                        ? "PENDING"
                                        : _vm.formAccount
                                            .userUpdateProfileLatestStatus === 1
                                        ? "APPROVED"
                                        : _vm.formAccount
                                            .userUpdateProfileLatestStatus === 9
                                        ? "INVALID"
                                        : "-"
                                    ) +
                                    "\n              "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: { padding: "25px 0" },
          attrs: { type: "flex", justify: "end", gutter: 20 }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _vm.showSave
                ? _c(
                    "el-button",
                    {
                      staticClass: "reset",
                      staticStyle: { width: "100%" },
                      on: { click: _vm.handleCancel }
                    },
                    [_vm._v("Cancel")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.formAccount.userStatus != "OPENED"
            ? _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _vm.showSave
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSave }
                        },
                        [_vm._v("Save")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.investmentPopup,
            width: "1500px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.investmentPopup = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "tabTitle",
              staticStyle: { width: "70%", margin: "0 auto" },
              attrs: { slot: "title" },
              slot: "title"
            },
            [
              _c(
                "el-tabs",
                {
                  attrs: { stretch: "" },
                  on: { "tab-click": _vm.handleTabClick },
                  model: {
                    value: _vm.activeTab,
                    callback: function($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab"
                  }
                },
                [
                  _c("el-tab-pane", { attrs: { label: "PDL", name: "PDLI" } }),
                  _vm._v(" "),
                  _c("el-tab-pane", { attrs: { label: "LOAN", name: "LOAN" } })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.activeTab == "PDLI"
            ? _c(
                "el-row",
                {
                  staticStyle: { "text-align": "left", "margin-top": "-20px" },
                  attrs: { gutter: 50 }
                },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c(
                      "h4",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          color: "rgb(0, 52, 72)",
                          "font-weight": "normal",
                          margin: "0"
                        }
                      },
                      [_vm._v("\n          Total Investment Amount\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-size": "16px",
                          color: "rgb(0, 52, 72)",
                          "font-weight": "600"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              "USD " +
                                _vm.$commonjs.currenyFormat(
                                  _vm.formAccount.totalInvestmentAmount.USD
                                ) +
                                " | " +
                                "CAD " +
                                _vm.$commonjs.currenyFormat(
                                  _vm.formAccount.totalInvestmentAmount.CAD
                                )
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c(
                      "h4",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          color: "rgb(0, 52, 72)",
                          "font-weight": "normal",
                          margin: "0"
                        }
                      },
                      [
                        _vm._v(
                          "\n          Gross Distribution Amount\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-size": "16px",
                          color: "rgb(0, 52, 72)",
                          "font-weight": "600"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              "USD " +
                                _vm.$commonjs.currenyFormat(
                                  _vm.formAccount.totalDistributionAmount.USD
                                ) +
                                " | " +
                                "CAD " +
                                _vm.$commonjs.currenyFormat(
                                  _vm.formAccount.totalDistributionAmount.CAD
                                )
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.activeTab == "LOAN"
            ? _c(
                "el-row",
                {
                  staticStyle: { "text-align": "left", "margin-top": "-20px" },
                  attrs: { gutter: 50 }
                },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c(
                      "h4",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          color: "rgb(0, 52, 72)",
                          "font-weight": "normal",
                          margin: "0"
                        }
                      },
                      [_vm._v("\n          Total Loan Amount\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-size": "16px",
                          color: "rgb(0, 52, 72)",
                          "font-weight": "600"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              "USD " +
                                _vm.$commonjs.currenyFormat(
                                  _vm.formAccount.totalLoanAmount.USD
                                ) +
                                " | " +
                                "CAD " +
                                _vm.$commonjs.currenyFormat(
                                  _vm.formAccount.totalLoanAmount.CAD
                                )
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c(
                      "h4",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          color: "rgb(0, 52, 72)",
                          "font-weight": "normal",
                          margin: "0"
                        }
                      },
                      [_vm._v("\n          Total Payment Amount\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-size": "16px",
                          color: "rgb(0, 52, 72)",
                          "font-weight": "600"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              "USD " +
                                _vm.$commonjs.currenyFormat(
                                  _vm.formAccount.totalPaymentAmount.USD
                                ) +
                                " | " +
                                "CAD " +
                                _vm.$commonjs.currenyFormat(
                                  _vm.formAccount.totalPaymentAmount.CAD
                                )
                            ) +
                            "\n        "
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { "text-align": "left" }, attrs: { gutter: 50 } },
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-button",
                    {
                      class:
                        _vm.subTabIndex == 0 ? "activeTabButton" : "TabButton",
                      attrs: { round: "", size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.handleSubTab("activeProjects", 0)
                        }
                      }
                    },
                    [_vm._v("Active Projects")]
                  ),
                  _vm._v(" "),
                  _vm.activeTab == "PDLI"
                    ? _c(
                        "el-button",
                        {
                          class:
                            _vm.subTabIndex == 1
                              ? "activeTabButton"
                              : "TabButton",
                          attrs: { round: "", size: "small" },
                          on: {
                            click: function($event) {
                              return _vm.handleSubTab("exitingProjects", 1)
                            }
                          }
                        },
                        [_vm._v("Exiting Projects")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      class:
                        _vm.subTabIndex == 2 ? "activeTabButton" : "TabButton",
                      attrs: { round: "", size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.handleSubTab("exitedProjects", 2)
                        }
                      }
                    },
                    [_vm._v("Exited Projects")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.activeTab == "PDLI"
            ? _c(
                "el-table",
                { attrs: { data: _vm.tableData, "max-height": "600px" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "projectName", label: "Project Name" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  scope.row.projectName
                                    ? scope.row.projectName
                                    : "-"
                                )
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      917148789
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "location", label: "Location" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  scope.row.location ? scope.row.location : "-"
                                )
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1976033781
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "purchaseAmount", label: "Purchase Amount" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.$commonjs.currenyFormat(
                                    scope.row.purchaseAmount
                                  )
                                )
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1290233634
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "purchaseDate",
                      label: "Last Purchase Date",
                      formatter: _vm.$commonjs.tableFormatDate,
                      sortable: ""
                    }
                  }),
                  _vm._v(" "),
                  _vm.showMore
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "distributionAmount",
                          label: "Distribution Amount"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.distributionAmount
                                        ? _vm.$commonjs.currenyFormat(
                                            scope.row.distributionAmount
                                          )
                                        : "-"
                                    )
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1440240653
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showMore
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "paymentDate",
                          label: "Last Payment Date",
                          formatter: _vm.$commonjs.tableFormatDate,
                          sortable: ""
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "dispositionStatus",
                      label: "Disposition Status"
                    }
                  })
                ],
                1
              )
            : _c(
                "el-table",
                { attrs: { data: _vm.tableData, "max-height": "600px" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "projectName", label: "Project Name" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                scope.row.projectName
                                  ? scope.row.projectName
                                  : "-"
                              )
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "location", label: "Location" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                scope.row.location ? scope.row.location : "-"
                              )
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "initialInvestment",
                      label: "Original Principal"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.$commonjs.currenyFormat(
                                  scope.row.initialInvestment
                                )
                              )
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "purchaseDate",
                      label: "Last Purchase Date",
                      formatter: _vm.$commonjs.tableFormatDate,
                      sortable: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "purchaseAmount",
                      label: "Outstanding Balance"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.$commonjs.currenyFormat(
                                  scope.row.purchaseAmount
                                )
                              )
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "paymentDate",
                      label: "Last Interest Cutoff Date",
                      formatter: _vm.$commonjs.tableFormatDate,
                      sortable: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "distributionAmount",
                      label: "Total Distribution"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.$commonjs.currenyFormat(
                                  scope.row.distributionAmount
                                )
                              )
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.myDocuments,
            width: "1500px",
            "close-on-click-modal": false,
            title: "My Documents"
          },
          on: {
            "update:visible": function($event) {
              _vm.myDocuments = $event
            }
          }
        },
        [
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-input", {
                          attrs: { maxlength: "50" },
                          nativeOn: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.submitSearch.apply(null, arguments)
                            }
                          },
                          model: {
                            value: _vm.searchData,
                            callback: function($$v) {
                              _vm.searchData = $$v
                            },
                            expression: "searchData"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "search",
                            staticStyle: { "margin-left": "10px" },
                            attrs: { type: "primary" },
                            on: {
                              click: function() {
                                _vm.submitSearch()
                              }
                            }
                          },
                          [_vm._v("Apply")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "reset",
                            on: {
                              click: function() {
                                _vm.clearSearch()
                              }
                            }
                          },
                          [_vm._v("Clear")]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "100%",
                          display: "flex",
                          "justify-content": "flex-end"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { "padding-right": "10px" } },
                          [
                            _c(
                              "el-dropdown",
                              {
                                ref: "filter",
                                staticStyle: {
                                  "margin-bottom": "22px",
                                  "margin-right": "20px"
                                },
                                attrs: { trigger: "click" }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "el-dropdown-link sortbox" },
                                  [
                                    _c("em", { staticClass: "filter" }),
                                    _vm._v(
                                      "\n                  Filter\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown"
                                  },
                                  [
                                    _c(
                                      "el-form",
                                      {
                                        ref: "formFilter",
                                        staticStyle: {
                                          width: "300px",
                                          padding: "14px 24px"
                                        },
                                        attrs: { model: _vm.formFilter }
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "12px"
                                            },
                                            attrs: { label: "Project Name" }
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  "popper-append-to-body": false,
                                                  filterable: "",
                                                  multiple: "",
                                                  clearable: ""
                                                },
                                                model: {
                                                  value: _vm.Products,
                                                  callback: function($$v) {
                                                    _vm.Products = $$v
                                                  },
                                                  expression: "Products"
                                                }
                                              },
                                              _vm._l(_vm.ProductsList, function(
                                                item,
                                                index
                                              ) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value
                                                  }
                                                })
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "12px"
                                            },
                                            attrs: { label: "Document Type" }
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  "popper-append-to-body": false,
                                                  multiple: "",
                                                  clearable: ""
                                                },
                                                model: {
                                                  value: _vm.type,
                                                  callback: function($$v) {
                                                    _vm.type = $$v
                                                  },
                                                  expression: "type"
                                                }
                                              },
                                              _vm._l(_vm.typeList, function(
                                                item,
                                                index
                                              ) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value
                                                  }
                                                })
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          {
                                            staticStyle: {
                                              "margin-bottom": "12px"
                                            },
                                            attrs: { label: "Document Date" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {},
                                              [
                                                _c("el-date-picker", {
                                                  attrs: {
                                                    type: "date",
                                                    placeholder: "option date"
                                                  },
                                                  model: {
                                                    value: _vm.date,
                                                    callback: function($$v) {
                                                      _vm.date = $$v
                                                    },
                                                    expression: "date"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "filterButton" },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                staticStyle: {
                                                  "margin-right": "15px",
                                                  "margin-bottom": "0"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticClass: "reset",
                                                    on: {
                                                      click: function($event) {
                                                        _vm.$refs.filter.hide()
                                                        _vm.clearSearch()
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Reset")]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-form-item",
                                              {
                                                staticStyle: {
                                                  "margin-bottom": "0"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    staticClass: "search",
                                                    attrs: { type: "primary" },
                                                    on: {
                                                      click: function() {
                                                        _vm.$refs.filter.hide()
                                                        _vm.filterSearch()
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Apply")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-dropdown",
                              {
                                staticStyle: { "margin-bottom": "22px" },
                                attrs: { trigger: "click" },
                                on: { command: _vm.handleCommand }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "el-dropdown-link sortbox" },
                                  [
                                    _c("em", { staticClass: "sort" }),
                                    _vm._v(
                                      "\n                  Sort by\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown"
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "desc" } },
                                      [_vm._v("Creation Date (New - Old)")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-dropdown-item",
                                      { attrs: { command: "asc" } },
                                      [_vm._v("Creation Date (Old - New)")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.documentsData }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "productName", label: "Project Name" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "description",
                        label: "Description",
                        width: "280"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "description",
                        label: "Document Type",
                        width: "280"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "documentCreationDate",
                        label: "Document Date",
                        width: "280",
                        formatter: _vm.$commonjs.tableFormatDateTime
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "View", width: "280" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  staticClass: "search",
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function() {
                                      _vm.viewbtn(
                                        scope.row.docNumber,
                                        scope.row.productName
                                      )
                                    }
                                  }
                                },
                                [_vm._v("View")]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              _vm._v(" "),
              _c("app-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": [5, 10, 20, 50],
                  total: _vm.total,
                  "page-size": _vm.currentSize
                },
                on: {
                  "size-change": function(v) {
                    _vm.currentSize = v
                    _vm.currentPage = 1
                    _vm.getDocuments()
                  },
                  "current-change": function(v) {
                    _vm.currentPage = v
                    _vm.getDocuments()
                  }
                }
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c763e28", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c763e28","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appUser/editUser.vue
// module id = null
// module chunks = 